import $ from "jquery";
import {Draggable, gsap} from "gsap/all";
import {BaseGameMars} from "../base/BaseGameMars";
import nunjucks from "nunjucks";
import {PillButton} from "../ui/PillButton";

export class TeamBuilder {

  constructor(app) {
    this.app = app;
    this.selectedMembers = [];

    this.aptitudeSums = {};
    this.aptitudeCounts = {};
    this.requirementCounts = {};
    this.baseLevel = 0;

    // The "Need a hint?" button stays grey, then takes the crew colors and pulses
    // if the player still hasn't pressed it this long after the tutorial
    this.hintCallSec = 20;
    this.hintCall = null;

    this.init();

    this.currentTimeline = gsap.timeline();
    this.selectTimeline = gsap.timeline();
  }

  init() {

    // Click on member to open his infos
    $(document).on("touchend click", ".group-members .member", (e) => {
      e.stopPropagation();

      if (e.type === "touchend") e.preventDefault();

      if (this.app.isDraggingMembers) return;

      if (this.isTeamCompleted()) return;

      const $item = $(e.currentTarget);
      const memberId = $item.data("member-id");

      if ($item.hasClass("is-active")) return;

      $(".group-members .member").removeClass("is-active");
      $item.addClass("is-active");

      this.selectMember(memberId);
    });

    // Click on the remove icon to remove an already-added member
    $(document).on(this.app.touchEvent, ".group-members .member .icon-remove", (e) => {
      e.stopPropagation();

      const $item = $(e.currentTarget).parents(".member");
      const memberId = $item.data("member-id");

      if (!$item.hasClass("is-added")) return;

      this.removeMember(memberId);
    });
  }

  // Open the member with the same id - info panel
  selectMember(memberId) {
    if ($(".team-complete").hasClass("is-active")) return;

    const $next = $(`.content-member[data-member-id="${memberId}"]`);
    if (!$next.length) return;

    const $current = $(".content-member.is-active").not($next);

    $next.removeClass("is-active");
    gsap.killTweensOf($next);
    gsap.set($next, {clearProps: "all"});

    $next.addClass("is-active");

    this.selectTimeline.kill();
    this.selectTimeline = gsap.timeline({
      onComplete: () => $current.removeClass("is-active")
    });

    if ($current.length) {
      this.selectTimeline.to($current, {xPercent: -100, duration: 0.4, ease: "power2.inOut"}, 0);
    }

    this.selectTimeline
      .fromTo($next, {xPercent: 100}, {xPercent: 0, duration: 0.4, ease: "power2.inOut"}, 0)
      .to("#lines", {opacity: 0}, 0);

  }

  // Find the first free (unused) slot index to place a newly added member
  getNextFreeSlot() {
    const totalSlots = $(".members-gradient[data-slot-index]").length;

    // i=0 → console.log(0) → is there a .member-selected[data-slot-index=0]? YES → keep looping
    // i=1 → console.log(1) → is there a .member-selected[data-slot-index=1]? YES → keep looping
    // i=2 → console.log(2) → is there a .member-selected[data-slot-index=2]? NO  → return 2
    for (let i = 0; i < totalSlots; i++) {
      if ($(`.member-selected:not(.removing)[data-slot-index=${i}]`).length === 0) return i;
    }

    return totalSlots;
  }

  // Updates the score of the Team for each of that member's aptitudes, sum or substract
  // depend if the member is add or remove from with sign 1 or -1.
  // sign is just a multiplier that turns "add to the total" into "subtract from the total" when its value is -1 instead of 1.
  applyMemberAptitudes(member, sign) {
    if (!member || !Array.isArray(member.aptitudes)) return;

    member.aptitudes.forEach((aptitude) => {
      const id = aptitude.id;
      if (!id) return;

      this.aptitudeSums[id] = (this.aptitudeSums[id] || 0) + sign * (aptitude.value || 0);
      this.aptitudeCounts[id] = (this.aptitudeCounts[id] || 0) + sign;

      this.updateAptitudeGauge(id);
    });
  }

  // How many members the selected crew asks for, the divisor of every team aptitude.
  getTeamSize() {
    return parseInt($("#screen-4 .crew").attr("data-members-count")) || 0;
  }

  // Team level for one aptitude, on the 0 to 100 scale of the gauges.
  // Each member carries an equal share of the bar, so a member at 100 on a crew of
  // four fills a quarter of it and only a full team of experts reaches the top.
  // Growth sits on top of the base level, which is the part of the bar a team starts with.
  getAptitudeLevel(id) {
    const count = this.aptitudeCounts[id] || 0;
    if (count <= 0) return 0;

    const teamSize = this.getTeamSize();
    if (teamSize <= 0) return 0;

    const growthRange = 100 - this.baseLevel;
    const share = Math.max(0, this.aptitudeSums[id] || 0) / (teamSize * 100);

    return Math.min(100, this.baseLevel + share * growthRange);
  }

  // Updates the gauge with the team's share of that aptitude
  updateAptitudeGauge(id) {
    const gauge = this.app.teamGauge[id]
    if (!gauge) return;

    gauge.animateToLevel(this.getAptitudeLevel(id));
  }

  // Check if any requirement has been met and add class
  // if a member has the requirement the class is-achivied is add to the requiremennt itself
  applyMemberRequirements(member, sign) {
    if (!member || !Array.isArray(member.requirements)) return;

    member.requirements.forEach((id) => {
      if (!id) return;

      this.requirementCounts[id] = (this.requirementCounts[id] || 0) + sign;

      const $requirement = $(`.group-team-requirements .requirement[data-id="${id}"]`);
      $requirement.toggleClass("is-achieved", this.requirementCounts[id] > 0);
    });
  }

  // Add member to slot in the Team
  // Update aptitudes and requirements
  addMember(memberId) {
    if (!memberId || this.isTeamCompleted()) return;

    // don't add the same member twice
    if ($(`.team-member-selected [data-member-id="${memberId}"]`).length) return;

    const member = this.app.data.content.team_members.members_list[memberId];
    if (!member) return;

    const $item = $(`.content-member[data-member-id="${memberId}"]`);
    $item.addClass("is-added");

    $(`.group-members .member[data-member-id="${memberId}"]`).addClass("is-added");
    $(`.group-members .member[data-member-id="${memberId}"]`).removeClass("is-active");

    BaseGameMars.killTimeline(this.currentTimeline)
    this.currentTimeline = gsap.timeline();

    this.currentTimeline.add(() => $(".content-info .placeholder-label").addClass("is-hidden"));
    this.currentTimeline.to($item, {
      scale: 0.85,
      duration: 0.5,
      ease: "power1.inOut",
    })
    this.currentTimeline.to($item, {
      opacity: 0,
      duration: 0.2,
      ease: "linear",
    }, "-=0.2");
    this.currentTimeline.add(() => this.checkTeamCompleted(), "+=0.2");
    this.currentTimeline.to("#lines", {opacity: 1}, "<");

    const slotIndex = this.getNextFreeSlot();
    this.selectedMembers.push(memberId);

    // Render member slot from nunjucks external template
    const $slot = $(nunjucks.render('templates/build-your-team/team-builder-member-selected.twig.html', {
      data: this.app.data,
      member: member,
      memberId: memberId,
      slotIndex: slotIndex,
    }));

    // Add slot content to DOM
    $(".team-member-selected").append($slot);

    gsap.timeline()
      .fromTo($slot, {alpha: 0, y: 20}, {alpha: 1, duration: 0.6, y: 0, ease: "power2.in"})
      .to($(`.member-slot-label-${slotIndex + 1}`, ".shape:visible"), {opacity: 0, duration: 0.4, ease: "power2.out", y: -50}, '<')
      .to(`.members-gradient[data-slot-index="${slotIndex}"]`, {opacity: 0.46, duration: 0.3, delay: 0.1, ease: "power2.out"}, "<")
      .fromTo($slot.find(".member-infos .inner"), {alpha: 0, x: -10}, {alpha: 1, duration: 0.6, x: 0, ease: "power2.out"})
      .to(`.members-gradient[data-slot-index="${slotIndex}"]`, {opacity: 0, duration: 0.3, ease: "power2.in"}, "+=0.3")

    this.applyMemberAptitudes(member, 1);
    this.applyMemberRequirements(member, 1);
  }

  // remove member to slot in the Team at the same spot that had been added
  // Update aptitudes and requirements
  removeMember(memberId) {
    if (!memberId) return;

    const $slot = $(`.team-member-selected [data-member-id="${memberId}"]`);
    if (!$slot.length) return;

    const slotIndex = parseInt($slot.attr("data-slot-index"), 10);
    // Free the slot immediately by adding removing class — don't wait for the fade-out animation to
    // finish, or a fast re-add could see this slot as still occupied.
    $slot.addClass("removing");
    this.selectedMembers = this.selectedMembers.filter((id) => id !== memberId);

    const member = this.app.data.content.team_members.members_list[memberId];
    this.applyMemberAptitudes(member, -1);
    this.applyMemberRequirements(member, -1);

    this.currentTimeline.to($slot, {
      alpha: 0,
      duration: 0.4,
      ease: "power2.out",
      onComplete: () => $slot.remove()
    });

    this.currentTimeline.to(`.member-slot-label-${slotIndex + 1}`, {opacity: 0.7, duration: 0.4, y: 0, ease: "power2.out"})

    const $item = $(`.content-member[data-member-id="${memberId}"]`);
    gsap.killTweensOf($item);
    gsap.set($item, {clearProps: "all"});
    $item.removeClass("is-added");

    $(`.group-members .member[data-member-id="${memberId}"]`).removeClass("is-added");
    $(".group-team-selected").removeClass("team-is-completed");

    this.checkTeamCompleted(memberId);
  }

  isTeamCompleted() {
    const totalSlots = this.getTeamSize();
    const usedSlotsCount = $(".member-selected:not(.removing)[data-slot-index]").length;

    return totalSlots > 0 && usedSlotsCount >= totalSlots;
  }

  // Check if the team is completed and display the "completed" class on the team container
  checkTeamCompleted() {
    const $teamComplete = $(".team-complete");

    gsap.killTweensOf($teamComplete);

    if (this.isTeamCompleted()) {
      $(".placeholder-label").addClass("is-hidden");
      if ($teamComplete.hasClass("is-active")) return;

      $teamComplete.addClass("is-active");
      $(".crew[data-crew-id]").addClass("team-completed");

      // Make sure to unselect any currently selecte member : this can happend when selecteing quickly
      const $anyActiveMember = $(".content-member.is-active");
      $(".member.is-active").removeClass("is-active");
      gsap.killTweensOf($anyActiveMember);
      gsap.to($anyActiveMember, {opacity: 0, duration: 0.3, ease: "power2.out"});

    } else {
      $teamComplete.removeClass("is-active")
      $(".placeholder-label").removeClass("is-hidden");
      $(".crew[data-crew-id]").removeClass("team-completed");
    }
  }

  getTeamTopAptitudes(limit = 3) {
    const crewId = $("#screen-4 .crew").attr("data-crew-id");
    const crewAptitudes = Object.keys(this.app.data.content.team_role[crewId].aptitude_targets);

    return $(".group-team-aptitudes .aptitude").toArray().map((el) => {
      const $el = $(el);
      const id = $el.data("id");
      return {id, level: this.getAptitudeLevel(id), $el};
    })
      .sort((a, b) => b.level - a.level)
      .sort((a, b) => crewAptitudes.includes(b.id) - crewAptitudes.includes(a.id))
      .slice(0, limit);
  }

  // "Need a hint?" button: glows the experts who meet one of the current crew's requirements
  showHint() {
    // Pressed: no need to call for attention anymore, but it takes the crew colors
    this.cancelHintCall();
    $("#screen-4 .hint-pill-button").removeClass("is-pulsing").addClass("is-colored");

    // Off first, then on again once the list has scrolled to them, so the glow
    // animation replays on every press and is seen
    const $members = $(".group-members .member").removeClass("is-highlighted");
    const $matches = $members.filter((i, el) => this.checksCrewRequirement($(el).data("member-id")));

    this.scrollToMember($matches.not(".is-added").first(), () => $matches.addClass("is-highlighted"));
  }

  // Start the countdown to the hint button calling for attention (colors + pulse)
  scheduleHintCall() {
    this.cancelHintCall();
    this.hintCall = gsap.delayedCall(this.hintCallSec, () => {
      this.hintCall = null;
      $("#screen-4 .hint-pill-button").addClass("is-colored is-pulsing");
    });
  }

  cancelHintCall() {
    if (this.hintCall) {
      this.hintCall.kill();
      this.hintCall = null;
    }
  }

  // True when the member meets one of the current crew's requirements
  checksCrewRequirement(memberId) {
    const crewId = $("#screen-4 .crew").attr("data-crew-id");
    const crewRequirements = (this.app.data.content.team_role[crewId]?.requirements || []).map((requirement) => requirement.id);
    const memberRequirements = this.app.data.content.team_members.members_list[memberId]?.requirements || [];
    return memberRequirements.some((id) => crewRequirements.includes(id));
  }

  // Scrolls the list to bring $member to the top, then calls onComplete.
  // Calls it right away when there is nothing to scroll.
  scrollToMember($member, onComplete) {
    const listing = $("#screen-4 .group-members .listing")[0];
    if (!listing || !$member.length) {
      onComplete();
      return;
    }

    const listingRect = listing.getBoundingClientRect();
    const memberRect = $member[0].getBoundingClientRect();
    const maxScroll = listing.scrollHeight - listing.clientHeight;
    const scrollTop = gsap.utils.clamp(0, maxScroll, listing.scrollTop + memberRect.top - listingRect.top - 20);

    if (Math.abs(scrollTop - listing.scrollTop) < 1) {
      onComplete();
      return;
    }

    gsap.to(listing, {
      scrollTop: scrollTop,
      duration: 0.8,
      ease: "power2.inOut",
      overwrite: true,
      onComplete: () => {
        Draggable.get(listing)?.update(); // so the next drag starts from here
        onComplete();
      }
    });
  }

  selectCrewType(crewId) {
    const crewData = this.app.data.content.team_role[crewId];

    // Add content to DOM (replace top screen content)
    $("#screen-4 .crew").attr("data-crew-id", crewId);
    $("#screen-4 .crew").attr("data-colors", crewData.glowColors.join(','));
    PillButton.refreshGlow("#screen-4 .pill-button[data-action='teamBuilder.addMember']", crewData.glowColors);
    $("#screen-4 .crew").attr("data-members-count", crewData.number_members);

    // Update top screen values: image and title
    $("#screen-4 .team-icon img").attr("src", crewData.image);
    $("#screen-4 .team-title .fr").html(crewData.title_with_break.fr);
    $("#screen-4 .team-title .en").html(crewData.title_with_break.en);

    // Update top screen values: aptitude targets. A crew only lists the aptitudes it
    // aims for, every other one is a target of 0. Screen 7 reads them back from here.
    for (const aptitudeId in this.app.data.content.aptitudes) {
      const target = crewData.aptitude_targets[aptitudeId] || 0;
      $(`#screen-4 .group-team-aptitudes .aptitude[data-id="${aptitudeId}"]`).attr("data-target", target);
      if (this.app.teamGauge[aptitudeId]) this.app.teamGauge[aptitudeId].setTarget(target);
    }

    // Update top screen values: requirements
    $("#screen-4 .group-team-requirements .requirement").remove();

    // Render requirement item from nunjucks external template
    const renderedRequirements = nunjucks.render('templates/build-your-team/team-builder-requirement.twig.html', {
      data: this.app.data,
      requirements: crewData.requirements
    });
    $("#screen-4 .group-team-requirements").append(renderedRequirements);

    // Bold text in a member's description only shows when they meet one of this crew's requirements
    $(".group-member-info .content-member").each((i, el) => {
      $(el).toggleClass("is-requirement-match", this.checksCrewRequirement($(el).data("member-id")));
    });
  }


  reset() {

    this.currentTimeline.kill();
    this.currentTimeline = gsap.timeline();

    $(".team-member-selected .member-selected").remove();
    $(".members-gradient").css("opacity", 0);
    gsap.set(".members-shapes [class^='member-slot-label-']", {opacity: 1, y: 0});

    $(".group-members .member, .content-member").removeClass("is-added is-active");
    $(".group-members .member").removeClass("is-highlighted");
    this.cancelHintCall();
    $("#screen-4 .hint-pill-button").removeClass("is-colored is-pulsing");
    $(".placeholder-label").removeClass("is-hidden");
    $(".team-complete").removeClass("is-active");

    const $item = $(`.content-member`);
    gsap.killTweensOf($item);
    gsap.set($item, {clearProps: "all"});

    this.aptitudeSums = {};
    this.aptitudeCounts = {};
    this.requirementCounts = {};
    this.selectedMembers = [];

    for (const id in this.app.teamGauge) {
      this.app.teamGauge[id].animateToLevel(0);
    }

    $(".group-team-requirements .requirement").removeClass("is-achieved");
    $(".group-team-selected").removeClass("team-is-completed");
  }
}
